import React from 'react'
import {createBrowserRouter} from 'react-router-dom'
import NoFound from "@/pages/404";
import { RouterEnum } from '@/libs/router';
import FSLogin from "@/pages/FSLogin";
import FSLoginHandler from "@/pages/FSLoginHandler";
// import SeoModal from "@/components/SeoModal";
// import Index from "@/pages/Index";
// import {RouterEnum} from "@/libs/router";
// import TaskLoading from "@/pages/TaskLoading";
// import {TaskFinished} from "@/pages/TaskFinished";
// import NewsControl from "@/pages/NewsControl";
// import FSLoginHandler from "@/pages/FSLoginHandler";
// import FSLogin from "@/pages/FSLogin";


const router = createBrowserRouter([
    // {
    //     path: '/404',
    //     element: (
    //         <Index/>
    //     )
    // },
    {
        path: RouterEnum.FSLoginHandler,
        element: <FSLoginHandler/>
    },
    {
        path: RouterEnum.FSLogin,
        element: <FSLogin/>
    },
    {
        path: '*',
        element: (
            <NoFound/>
        )
    },
    // {
    //     path: RouterEnum.Index,
    //     element: (
    //         <Index/>
    //     )
    // },
    // {
    //     path: RouterEnum.login,
    //     element: (
    //         <Index/>
    //     )
    // },
    // {
    //     path: RouterEnum.taskLoading,
    //     element: (
    //         <TaskLoading/>
    //     )
    // }, {
    //     path: RouterEnum.taskFinished,
    //     element: (
    //         <TaskFinished/>
    //     )
    // }, {
    //     path: RouterEnum.newsControl,
    //     element: <NewsControl/>
    // },


    // {
    //     path: RouterEnum.seoNews,
    //     element: <SeoModal/>
    // }
])

export default router;
